import {
    useMemo,
} from 'react'

import Card from 'app/shared-components/Card'
import SkyNetTable from 'app/shared-components/SkyNetTable'
import useCardForTableStyles from 'app/tss/cardForTable'
import requestConfig from 'app/requests/Order/Order.requests'

import useLinkStyles from 'app/tss/link.styles'

import {
    WithId,
} from 'app/types/common.types'
import useOrderLink from 'app/hooks/useOrderLink/useOrderLink'
import PreBookings from '../components/PreBookings'
import inboundOrdersConfig from './inboundOrders.config'
import outboundOrdersConfig from './outboundOrder.config'
import useStyles from './RelatedOrders.styles'

const RelatedOrders = ({
    id,
}: Readonly<WithId<number>>) => {
    const {
        classes,
    } = useStyles()
    const {
        classes: cardClasses,
    } = useCardForTableStyles()
    const {
        classes: linkClasses,
    } = useLinkStyles()

    const getOrderLink = useOrderLink()

    const outboundOrderTableConfig = useMemo(() => {
        return outboundOrdersConfig({
            getOrderLink,
            linkStyle: linkClasses.tableLink,
        })
    }, [
        getOrderLink,
        linkClasses.tableLink,
    ])
    const inboundOrderTableConfig = useMemo(() => {
        return inboundOrdersConfig(
            {
                getOrderLink,
                linkStyle: linkClasses.tableLink,
            },
        )
    }, [
        getOrderLink,
        linkClasses.tableLink,
    ])

    return (
        <>
            <Card
                className={cardClasses.root}
                title="Outbound Orders"
            >
                <SkyNetTable
                    name="RelatedOrders-OutboundOrder"
                    tableConfig={outboundOrderTableConfig}
                    customUrl={requestConfig.truckingCapacityOutbound().url}
                    simple
                    className={classes.table}
                    filters={{
                        serviceCenterId: id,
                    }}
                    showSearch
                />
            </Card>
            <PreBookings
                serviceCenterId={id}
                className={classes.table}
            />
            <Card
                className={cardClasses.root}
                title="Inbound Orders"
            >
                <SkyNetTable
                    name="RelatedOrders-InboundOrder"
                    tableConfig={inboundOrderTableConfig}
                    customUrl={requestConfig.truckingCapacityInbound().url}
                    simple
                    className={classes.table}
                    filters={{
                        serviceCenterId: id,
                    }}
                    showSearch
                />
            </Card>
        </>
    )
}

export default RelatedOrders
